

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { iconos } from "../../data";







export const LayoutDesplegable = ({ children, titulo, subtitulo, menu, disabled=true }) => {


    const navigate = useNavigate();
    const [anchorElUser, setAnchorElUser] = useState(null);


    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };


    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };



    return (

        <Box sx={{ display:'flex', flexDirection:'column', width:'100%', height:'100%', minHeight:0, overflowY:'auto' }}>
            <Grid container direction='row' alignItems='center'>
                <Box flex={1} />

                <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', lineHeight:1 }}>
                    <Typography variant="h2" sx={{fontSize:{ xs:"1rem", sm:"1.2rem", md:"1.7rem" }, fontWeight:600, textAlign:'center'}}>
                        { titulo }
                    </Typography>

                    {subtitulo && (
                    <Box sx={{ display:'flex', alignItems:'center' }}>
                        <Typography sx={{ color:'#757575', fontSize:'1rem', fontWeight:500, letterSpacing:'0.5px', textAlign:'center' }}>
                            { subtitulo }
                        </Typography>
                    </Box>
                    )}
                </Box>
                

                <Box flex={1} sx={{ display:'flex', justifyContent:'flex-end' }}>
                {(disabled) 
                ?   <Box>
                        <Tooltip title="Opciones de Página">
                            <IconButton onClick={handleOpenUserMenu} color="secondary"
                                sx={{ color:'white', backgroundColor:'secondary.main', width:45, height:45, '&:hover':{backgroundColor:'secondary.dark'} 
                            }}>
                                { iconos['menu'] }
                            </IconButton>
                        </Tooltip>

                        <Menu sx={{ mt:'47px', width:'300px' }} open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu} anchorEl={anchorElUser}
                            anchorOrigin={{ vertical:'top', horizontal:'right' }}
                            transformOrigin={{ vertical:'top', horizontal:'right' }}
                        >
                            {menu?.map((m) => (
                            <MenuItem key={m.title} onClick={m?.action}>
                                { m.icon }
                                <Typography variant="body2" ml={1}>{ m.title }</Typography>
                            </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                
                :   <IconButton onClick={() => navigate(-1)} sx={{ color:'#fff', backgroundColor:'secondary.main'}}>
                        {iconos['back']}
                    </IconButton>
                }
                </Box>
            </Grid>


            {/* Contenido */}
            <Box sx={{ flex:1, display:'flex', flexDirection:'column', mt:3 }}>
                {children}
            </Box>
        </Box>
    )
}
